export const isEmbedded = () => window.self !== window.top



// WEBPACK FOOTER //
// ./src/core/utils/EmbeddedPage.js